<script setup lang="ts">
import AppLogoIcon from '@/components/AppLogoIcon.vue';
import { computed } from 'vue';

interface Props {
    size?: 'sm' | 'md' | 'lg';
}

const props = withDefaults(defineProps<Props>(), {
    size: 'md'
});

const iconSize = computed(() => {
    switch (props.size) {
        case 'sm': return 'h-16 w-auto';
        case 'md': return 'h-24 w-auto';
        case 'lg': return 'h-40 w-auto';
        default: return 'h-24 w-auto';
    }
});
</script>

<template>
    <AppLogoIcon class="flex-shrink-0" :class="iconSize" />
</template>
